import React from 'react'

export type PillTab<K extends string> = {
  key: K
  label: string
  count?: number
  testId?: string
}

export type PillTabsProps<K extends string> = {
  tabs: PillTab<K>[]
  active: K
  onChange: (key: K) => void
  ariaLabel: string
  testId?: string
}

// Office UX v0 (findings #94/#95): the pill tab strip Inventario uses for its
// categories, shared by Editar instalación and Lotes.
export default function PillTabs<K extends string>({ tabs, active, onChange, ariaLabel, testId }: PillTabsProps<K>) {
  return (
    <div role="tablist" aria-label={ariaLabel} data-testid={testId} style={{ display: 'flex', gap: 6, flexWrap: 'wrap', margin: '4px 0 12px' }}>
      {tabs.map((tab) => {
        const selected = tab.key === active
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={selected}
            data-testid={tab.testId}
            onClick={() => onChange(tab.key)}
            style={{
              minHeight: 40,
              padding: '6px 14px',
              borderRadius: 999,
              border: selected ? '2px solid #1d4ed8' : '1px solid #d1d5db',
              background: selected ? '#eff6ff' : '#ffffff',
              color: '#0f172a',
              fontWeight: selected ? 800 : 600,
              cursor: 'pointer'
            }}
          >
            {tab.count === undefined ? tab.label : `${tab.label} (${tab.count})`}
          </button>
        )
      })}
    </div>
  )
}
